export default {
      id: "trash-usage",
      viewBox: "0 0 10 10",
      url: __webpack_public_path__ + "img/icons.31feac93.svg#trash",
      toString: function () {
        return this.url;
      }
    }